module.exports = __webpack_public_path__ + "img/offer-detail-logo.4e502ee8.png";